// dependancies
import React from "react";
import PropTypes from "prop-types";

// components
import Label from "../label/Label";
import InputGroup from "../input_group/InputGroup";

// styled components
import SelectStyled from "./Select.styled";

const Select = React.forwardRef((props, ref) => {
  const {
    /**
     * `id` sets the id of the select, is a string and isRequired
     */
    id,
    /**
     * `name` sets the name of the select, is a string and isRequired
     */
    name,
    /**
     * `required` sets the requirement of the select and is a boolean
     */
    required,
    /**
     * `error` boolean to set if the select has an error
     */
    error,
    /**
     * `labelText` sets the label text, is a string and isRequired
     */
    labelText,
    /**
     * `change` onChange function
     */
    change,
    /**
     * `focus` onFocus function
     */
    focus,
    /**
     * `blur` onFocus function
     */
    blur,
    /**
     * `focused` boolean to check if select is focused
     */
    focused,
    /**
     * `options` array that needs to be passed as props. the array needs to include ia and value and isRequired
     */
    options,
    /**
     * `defaultValue` defaultValue for the select and isRequired
     */
    defaultValue,
    /**
     * `selectedValue` selectedValue for the select
     */
    selectedValue,
    /**
     *  `covert` covert style boolean for the select
     */
    covert,
    /**
     * `disabledd` disabled attribute for the select
     */
    disabled,
    /**
     * `ariaDescribedby` aria-describedby attribute for the select
     */
    ariaDescribedby,
    /**
     * `ariaInvalid` aria-invalid attribute for the select
     */
    ariaInvalid,
    /**
     * `showLabel` showLabel attribute for the select
     */
    showLabel,
    /**
     * `handler` event handler at the end of the select
     */
    handler,
     /**
     * `isGreen` options appear in a green background
     */
     isGreen,
  } = props;

  const getOptionText = (item, isSelected, value) => {
    if (isSelected) {
      return 
    }

    if (selectedValue === "handler") {
        handler.handlerFunction()
    }
    
    return item.description && focused ?  `${item.name ? item.name : item.value} - ${item.description}` : null;
  };
  return (
    <SelectStyled
      error={error}
      focused={focused}
      covert={covert}
      showLabel={showLabel}
    >
      <InputGroup>
        {labelText && <Label htmlFor={name} text={labelText} />}
        <select
          id={id}
          name={name}
          required={required}
          onChange={change}
          onFocus={focus}
          onBlur={blur}
          defaultValue={selectedValue || defaultValue}
          disabled={disabled}
          aria-describedby={ariaDescribedby}
          aria-invalid={ariaInvalid}
          ref={ref}
        >
          <option disabled value={defaultValue}>
            {defaultValue}
          </option>
          {/* Loop the options passed in via props */}
          {options &&
            options.map((item) => {
              const isSelected = selectedValue === item.value;
              return (
                <option
                  key={item.id}
                  data-value={item.available}
                  value={item.value}
                >
                 {item.description ? getOptionText(item, isSelected, item.value) : item.name ? item.name : item.value}
                </option>

              );
            })}
           {handler && <option className="isGreen" key={handler && handler.handlerLabel && handler.handlerLabel.id}
                  value={handler && handler.handlerLabel && handler.handlerLabel.value}>{handler&& handler.handlerLabel &&  handler.handlerLabel.name}</option>}
        </select>
      </InputGroup>
    </SelectStyled>
  );
});

// props validation
Select.propTypes = {
  id: PropTypes.string.isRequired,
  labelText: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired, // used to populate the select options
  defaultValue: PropTypes.string.isRequired, // used to set the defaultValue
  selectedValue: PropTypes.string, // used to set the selected value
  change: PropTypes.func,
  focus: PropTypes.func,
  blur: PropTypes.func,
  focused: PropTypes.bool,
  required: PropTypes.bool,
  error: PropTypes.bool,
  covert: PropTypes.bool,
  disabled: PropTypes.bool,
  ariaDescribedby: PropTypes.string,
  ariaInvalid: PropTypes.string,
};

export default Select;
